import {
  Component,
  OnInit,
  Output,
  Input,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-eventlog-detail',
  templateUrl: './eventlog-detail.component.html',
  styleUrls: ['./eventlog-detail.component.scss']
})
export class EventlogDetailComponent implements OnInit {
  @Input() selectedEventLog: any;
  @Input() isOpened = false;
  @Output() isOpenedChange = new EventEmitter<boolean>();


  ngOnInit(): void {
  }

  onClosePanel = () => {
    this.isOpened = false;
    this.isOpenedChange.emit(this.isOpened);
  };
}
